<template>

<div class="spec-view" v-if="spec" :class="specView_cls">

	<box>

		<div class="specsheet">

			<div class="heypart">
				<p v-if="0">
					<b>Hey &mdash; </b>
					Vi ved godt at vores opgavespecifikationer kan være til den tørre side. 
					Dog er de ret vigtige at du alligevel bruger et øjeblik på at nærlæse, da det er vigtigt at vi er helt 
					enige om det arbejde der skal laves og dine forventninger og krav dertil. 
					På den måde får vi en super tilfreds kunde, hvilket er det vigtigste for os. 
					Det er derfor super vigtigt at dine forventninger til arbejdet og den løsning vi udfører er definerede 
					i vores specifikation nedenfor, så der ikke senere opstår tvivl.
				</p>
				<p v-if="0">
					I Milk går vi meget op i at du som kunde er 100% tilfreds med din løsning.
					Derfor nørder vi altid opgavespecifikation &mdash; selvom det ikke er den sjoveste del.<br>
					Vi beder dig her hjælpe med at sikre at dine ønsker og forventninger til opgaven, samt eventuelle detaljer, er klart beskrevet i punkterne nedenfor.
				</p>
				<p v-if="1">
					Vi går meget op i at du som kunde bliver 100% tilfreds med din løsning, og derfor nørder vi altid opgavespecifikationen.
					Vi beder dig hjælpe med at sikre at dine ønsker er klart beskrevet, så forventninger og detaljer bliver afstemt inden projektopstart.
				</p>
			</div>

			<div class="pretitle" v-html="pretitle"></div>
			<h1 class="h1">{{title}}</h1>
			<br>

			<p v-html="legaltext1"></p>
			<br>

			<p v-if="legaltext2" v-html="legaltext2"></p>

			<div class="taskcats">
				<div class="taskcat" v-for="(taskcat,taskcat_i) in spec.taskcats" :key="'asdf'+taskcat_i">

					<div class="row row-taskcat">
						<div class="col">
							<input type="text" v-model="taskcat.title" class="input-taskcat-title" placeholder="Kategori">
						</div>
						<div class="col">

						</div>
						<div class="col">
							<div class="hrs-title">Arbejdstimer</div>
						</div>
						<div class="col">

						</div>
						<div class="col">
							<div v-if="false" class="dragger">=</div>
							<div class="taskcat-up-down">
								<div class="up" v-if="taskcat_i>0" @click="taskCatMoveUp(taskcat,taskcat_i)"></div>
								<div class="down" v-if="taskcat_i < ( spec.taskcats.length - 1 )" @click="taskCatMoveDown(taskcat,taskcat_i)"></div>
							</div>
						</div>
						<div class="col">
							<div class="taskcat-delete-btn" @click="taskcatDelete(taskcat,taskcat_i)" v-if="spec.taskcats.length > 1">
								<svgicon icon="ionicons/ios-trash-outline"></svgicon>
							</div>
						</div>
					</div>


					<div class="tasks">
						<draggable v-model="taskcat.tasks" :options="{ group: 'tasks', handle: '.dragger' }" @start="task_drag_start" @end="task_drag_end" @add="task_drag_add" @remove="task_drag_remove">
							<div class="task" :class="taskClasses(task)" v-for="(task,task_i) in taskcat.tasks" :key="'task'+task_i">
   							<div class="row row-task">
								<div class="col">
   									<textarea :ref="'taskTitle'+taskcat_i+'-'+task_i" class="input-task-title" rows="1" data-min-rows="1" placeholder="Opgavelinje" v-model="task.title" @input="autoSizeTextArea(taskcat_i,task_i)"></textarea>
									<textarea v-if="spec.showDescriptions" :ref="'taskText'+taskcat_i+'-'+task_i" class="input-task-text" rows="1" data-min-rows="1" placeholder="?" v-model="task.text" @input="autoSizeTextArea2(taskcat_i,task_i)"></textarea>
   		 						</div>
   		 						<div class="col">
   									<div class="task-optional" @click="toggleTaskOptional(task)">
											<template v-if="1+1==2">
												<template v-if="task.optional===undefined">&mdash;</template>
												<template v-if="task.optional===false">Tilvalg</template>
												<template v-if="task.optional===true">Tilvalg</template>
											</template>
											<template v-if="1+1==3">
												<svgicon v-if="task.optional===undefined" icon="ionicons/ios-minus-empty"></svgicon>
												<svgicon v-if="task.optional===false" icon="ionicons/android-close"></svgicon>
												<svgicon v-if="task.optional===true" icon="ionicons/checkmark"></svgicon>
											</template>
   								  </div>
   		 						</div>
   		 						<div class="col">
   									<input type="number" v-model.number="task.hours" class="input-hours" :tabindex="666+(taskcat_i*100)+task_i">									
   		 						</div>
   								<div class="col">
   									<div class="task-budget" v-if="spec.showLineTotals">
   										{{outputMoney((task.hours*hour_rate))}}										
   									</div>
   								</div>
									<div class="col">
										<div class="dragger">=</div>
									</div>
									<div class="col">
										<div class="task-delete-btn" @click="taskDelete(task,task_i,taskcat,taskcat_i)">
											<svgicon icon="ionicons/ios-trash-outline"></svgicon>
										</div>
									</div>
   		 					</div>
   						</div>
						</draggable>
					</div>

					<div class="subtotal">
						<div class="row row-subtotal">
							<div class="col">
								<span class="add-task-entry" @click="addTask(taskcat_i)">
									Indsæt række
								</span> &nbsp; 
								<span class="add-task-entry" @click="addTaskcat(taskcat_i)">
									kategori
								</span> &nbsp; 
								<span class="add-task-entry" @click="triggerSpecLineRobot(taskcat_i)">
									forslag
								</span>								
							</div>
							<div class="col">

							</div>
							<div class="col" v-if="spec.showCatHrs">
								<div class="subtotal-hours">
									{{getCatTotalHours(taskcat)}}									
								</div>
							</div>
							<div class="col">
								<div class="subtotal-budget" v-if="spec.showCatTotals">
									{{outputMoney(getCatTotalBudget(taskcat))}}
								</div>
							</div>
							<div class="col">
							</div>
							<div class="col">
							</div>
						</div>
					</div>

				</div>
			</div>

			<div v-if="!spec.taskcats || !spec.taskcats.length" class="textlink" @click="addTaskcat()">
				TIlføj kategori
			</div>

			<div class="total" v-if="spec.taskcats && spec.taskcats.length">
				<div class="row row-total">
					<div class="col">
						<div class="total-title">
							Total ex. moms
						</div>
					</div>
					<div class="col">

					</div>
					<div class="col">
						<div class="total-hours">
							{{ total_hours }}							
						</div>
					</div>
					<div class="col">
						<div class="total-budget">							
							kr. {{ total | money(2) }}
						</div>
					</div>
				</div>
			</div>


			<div v-if="false" class="btn add-task" @click="addTask()">Tilføj række</div>

			<p v-if="legaltext_below" v-html="'<br><br>'+legaltext_below"></p>

			<div class="notes-section">
				<h4 class="">Betingelser</h4>

				<p v-html="notes_text"></p>

				<textarea ref="notesTextArea" class="notes-text-input" :class="{empty:(!spec.notes.length)}" rows="3" data-min-rows="1" placeholder="Særlige betingelser?" v-model="spec.notes" @input="autoSizeTextAreaNotes()"></textarea>

			</div>

			
			<div class="spec-footer">
				<div class="footer-logo"><svgicon icon="logo"></svgicon></div>
				<div>Milk Studio ApS, Strandgade 70, 1. 1401 København K. CVR 38750224</div>
			</div>

		</div>

		</box>



	<box label="Visning" :open="false" header-toggle cls="print-invisible">
      <div class="cols cols-4">			

			<btn color="secondary" full @click.native="toggleShowDescriptions()">
				<template v-if="this.spec.showDescriptions">● Tekstbeskrivelser</template>
				<template v-else>○ Tekstbeskrivelser</template>
			</btn>

			<btn color="secondary" full @click.native="toggleSpecSetting('showLineTotals')">
				<template v-if="spec.showLineTotals">● Linje-totaler</template>
				<template v-else>○ Linje-totaler</template>
			</btn>

			<btn color="secondary" full @click.native="toggleSpecSetting('showCatHrs')">
				<template v-if="spec.showCatHrs">● Kategori-timer</template>
				<template v-else>○ Kategori-timer</template>
			</btn>

			<btn color="secondary" full @click.native="toggleSpecSetting('showCatTotals')">
				<template v-if="spec.showCatTotals">● Kategori-totaler</template>
				<template v-else>○ Kategori-totaler</template>
			</btn>

		</div>
    </box>
	
	
	<box cls="print-invisible">

		<div class="grid">
			<div class="col m25">

				<inputfield label="Dato">
					<input type="date" v-model="spec.date">
				</inputfield>

			</div>
			<div class="col m25">

				<btn full color="secondary" @click.native="cloneSpec()">Kopiér fra...</btn>
				
			</div>
			<div class="col m25">

				<btn full color="secondary" @click.native="downloadPDF()">Download PDF</btn>

			</div>
			<div class="col m25">

				<btn full @click.native="save()" color="primary">Gem</btn>

			</div>
		</div>

	</box>


</div>
</template>

<script>
import fdb from '.././firebase_config.js';
import helpers from '../helpers.js';
import mixins from '../mixins.js'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Specsheet from '.././components/Specsheet'
import Inputfield from '.././components/Inputfield'
import './../components/generated_svg_icons/ionicons/ios-trash-outline'
import './../components/generated_svg_icons/ionicons/checkmark'
import './../components/generated_svg_icons/ionicons/android-close'
import './../components/generated_svg_icons/ionicons/ios-minus-empty'
import './../components/generated_svg_icons/logo'
import Avatar from '.././components/Avatar'
import moment from 'moment'
import draggable from 'vuedraggable'
import autosize from 'autosize'


export default {
	props: [ 'localspec' ],
	mixins: [ mixins.db, mixins.generic ],
	components: {
		Box,
		Btn,
		Avatar,
		Inputfield,
		draggable,
		Specsheet, 
	},
	data: function() { return {
		spec: undefined,
		specLineRobot_insertAtTaskcatIndex: undefined,	
	} },
	computed: {

		client(){ return this.$store.getters['clients/getOne'](this.project.client_key) },
		project(){ return this.$store.getters['projects/getOne'](this.spec.project_key) },
		hour_rate(){ return this.$store.getters['projects/get_hour_rate']( this.project ) },
		total(){ return this.$store.getters['specs/getTotal'](this.spec) },
		total_hours(){ return this.$store.getters['specs/getHours'](this.spec) },

		pretitle(){
			var t = ''
			//t += this.client.name + ' / ' + this.project.name + ' / '
			//if( this.project.payment_model == 'fixed_price' ) t += 'Tilbud'
			//if( this.project.payment_model == 'time_expense' ) t += 'Tilbud'
			t += 'Prisoverslag'
			if( this.spec.date ) t += ' &mdash; ' + this.spec.date
			return t
		},

		title(){
			var t = ''
			t += this.client.name + ': ' + this.project.name
			//if( !this.project ) return 'Ny opgave'
			//return this.project.name
			return t
		},

		legaltext1(){
			var t

			if( this.project.payment_model == 'fixed_price' ) {
				//t = 'Der afgives tilbud på nedenstående arbejde. Priser angivet nedenfor er faste priser.'
			}
			if( this.project.payment_model == 'time_expense' ) {
				//t = 'Der afgives tilbud på ud fra nedenstående estimater og aftalt timepris på '+this.hour_rate+' kr.'
			}			

			return t
		},

		legaltext2(){
			return
			return 	'I Milk Studio arbejder vi både med faste priser og almindelig timepris.<br>' +
					'&mdash; Fordelen ved faste priser er at du ved præcis hvad en given løsning kommer til at koste.<br>' +
					'&mdash; Timepris er typisk langt billigere for dig, idet det effektive arbejde kan påbegyndes nærmest direkte uden der skal bruges tid på budget, tilbud og andet overhead.'
		},

		legaltext_below(){
			if( this.project.payment_model == 'fixed_price' ) return 'Priser angivet ovenfor er faste priser.'
			if( this.project.payment_model == 'time_expense' ) return 'Der afregnes på timebasis '+this.project.hour_rate+' kr. med udgangspunkt i ovenstående estimater.'			
		},

		notes_text(){
			var t
			if( this.project.payment_model == 'fixed_price' ) {
				t = 'Prisoverslag er beregnet ud fra gældende timepris på '+this.hour_rate+' kr. ekskl. moms. '
			}
			if( this.project.payment_model == 'time_expense' ) {
				t = 'Prisoverslag er beregnet ud fra gældende timepris på '+this.hour_rate+' kr. ekskl. moms. '
					'Ved opgaveafslutning afregnes opgaven efter forbrugt arbejdstid. Kunden har krav på opgørelse for arbejdstid såfremt en sådan ønskes. ' +
					'Milk Studio forpligter sig til at advisere kunden i tilfælde af at arbejdets omfang overstiger ovenstående estimater i væsentligt omfang. ' + 
					'Kunden fra til enhver tid ret til at bede Milk Studio afslutte opgaven hvorefter der vil blive afregnet ud fra opbrugt arbejdstid.<br>'
			}
			
			t += 'Alle priser angivet ovenfor er angivet ekskl. moms. '
			t += 'Fakturering er som udgangspunkt 50% ved opstart og 50% ved opgavens afslutning.'
			t += '<br>Vi gør opmærksom på vores generelle forretningsbetingelser som kan ses på https://milk-studio.dk/forretningsbetingelser.pdf'

			return t
			
		},

		specView_cls(){
			var cls = {}						
			cls[ 'spec-type-' + this.project.payment_model ] = true
			return cls
		},

	},
	methods: {

		getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,

		toggleSpecSetting( key ){
			if( this.spec[key] == undefined ) this.$set( this.spec, key, false )
			this.spec[key] = !this.spec[key]
		},


		task_drag_start(e){
			//console.log('start')
			//console.log(e)

		},

		task_drag_end(e){
			//console.log('end')
			//console.log(e)
			//console.log( e.oldIndex + ' > ' + e.newIndex )
			//console.log( e.from + ' > ' + e.newIndex )
		},

		task_drag_remove(e){
			console.log('remove: ' + e.oldIndex + ' > ' + e.newIndex )
		},

		task_drag_add(e){
			console.log(e)
			console.log('add: ' + e.oldIndex + ' > ' + e.newIndex )
			this.autoSizeTextAreasDelayed()
		},

		updateTaskTitle(taskcat_i,task_i){
			var el = this.$refs[ 'taskTitle'+taskcat_i+'-'+task_i ][0]
			var val = el.textContent
			this.$set( this.spec.taskcats[taskcat_i].tasks[task_i], 'title', val )
		},

		updateTaskText(taskcat_i,task_i){
			var el = this.$refs[ 'taskText'+taskcat_i+'-'+task_i ][0]
			var val = el.textContent
			this.$set( this.spec.taskcats[taskcat_i].tasks[task_i], 'text', val )
		},

		triggerSpecLineRobot( taskcat_i ){
			this.specLineRobot_insertAtTaskcatIndex = taskcat_i
			this.$store.commit('set__specLineRobot_active',true)
		},

		specLineRobot_onSelectEntry( task ){
			
			if(!this.spec.taskcats.length) {
				this.addTaskcat()
			}
			
			var taskcat_index = this.specLineRobot_insertAtTaskcatIndex

			if( taskcat_index == undefined ) taskcat_index = this.spec.taskcats.length - 1

			if( !this.spec.taskcats[ taskcat_index ].tasks ) {
				this.$set( this.spec.taskcats[ taskcat_index ], 'tasks', [] )
			}
			this.spec.taskcats[ taskcat_index ].tasks.push(task)
			
			this.specLineRobot_insertAtTaskcatIndex = undefined
			this.spec.showDescriptions = true

			this.autoSizeTextAreasDelayed()

		},

		outputMoney: helpers.outputMoney,

		change(key, e) {
			var val = e.target.value
			this.changes[key] = val
		},

		goto(url) {
			this.$router.push(url)
		},

		hasExistingAcceptedSpec(data){
			if( data.status != 'accepted' ) return false
			if( !data.project_key ) return false
			var existing_accepted_spec = this.getProjectAcceptedSpec(data.project_key)
			if( !existing_accepted_spec ) return false
			if( existing_accepted_spec['.key'] == data['.key'] ) return false
			return true
		},

		save() {

			globals.big_spinner = true
			var id = this.$route.params.id
			var data = JSON.parse(JSON.stringify(this.spec))

			if( this.hasExistingAcceptedSpec(data) ) {
				eventBus.$emit('toast', {
					text: '<br>Der er allerede accepteret spec for denne opgave.<br><br>Du kan ikke gemme flere accepterede specs på samme opgave.<br><br>'
				})
				return false
			}

			delete data['.key']

			fdb.ref('specs').child(id).update(data)      
			
			eventBus.$emit('toast', {
				text: 'Saved'
			})
			globals.big_spinner = false
			eventBus.$emit('triggerIconSignal', 'thumbsup')
		},



		archiveSpec() {
			var confirmed = confirm('Sikker?')
			if (!confirmed) return
			var key = this.$route.params.id

			fdb.ref('specs').child(key).update({
				archived: true
			})
			this.$router.replace('/specs')
			eventBus.$emit('toast', {
				text: 'Spec arkiveret'
			})
		},

		getCatTotalHours(taskcat){
			var total_hrs = 0
			for( var i in taskcat.tasks ) {
				var task = taskcat.tasks[i]
				if( task.optional == false ) continue
				total_hrs += parseFloat(task.hours)
			}
			return total_hrs
		},

		getCatTotalBudget(taskcat){
			var hrs = this.getCatTotalHours(taskcat)
			return hrs * this.hour_rate
		},

		addTask(taskcat_index){
			if(!this.spec.taskcats.length) {
				this.addTaskcat()
			}
			var task = { title:'', text:'', hours: 0, optional:undefined, }

			if( taskcat_index == undefined ) taskcat_index = this.spec.taskcats.length - 1

			if( !this.spec.taskcats[ taskcat_index ].tasks ) {
				this.$set( this.spec.taskcats[ taskcat_index ], 'tasks', [] )
			}
			this.spec.taskcats[ taskcat_index ].tasks.push(task)
		},

		addTaskcat(taskcat_i){
			
			var task = { title:'', text:'', hours: 0, optional:undefined, }
			var taskcat = { title:'Opgaver', tasks:[ task ] }
			if( !this.spec.taskcats ) {
				this.$set( this.spec, 'taskcats', [] )
			}
			if( taskcat_i === undefined ) {
				this.spec.taskcats.push(taskcat)
			}
			if( taskcat_i !== undefined ) {
				//this.spec.taskcats[ taskcat_index ].push(taskcat)
				this.spec.taskcats.splice(taskcat_i+1, 0, taskcat)
			}

			this.toast('Kategori tilføjet')
			
		},

		specElementInSpec(specelement_key){
			if( !this.spec.specelements ) return false
			if( !this.spec.specelements[specelement_key] ) return false
			if( !this.spec.specelements[specelement_key].active ) return false
			return true
		},

		toggleSpecElementInSpec(specelement_key){
			var inAlready = this.specElementInSpec(specelement_key)
			if( !this.spec.specelements[specelement_key] ) {
				this.$set( this.spec.specelements, specelement_key, {active:undefined} )
			}

			this.spec.specelements[specelement_key].active = !inAlready

			// no pairs - put to own func
			if( !inAlready ) {
				var specelement = globals.specelements[specelement_key]
				if( specelement['no_pairing'] ) {
					for( var i = 0; i < specelement.no_pairing.length; i++ ) {
						var pair_element_key = specelement.no_pairing[i]
						if( this.specElementInSpec(pair_element_key) ) {
							this.spec.specelements[pair_element_key].active = false
						}
					}
				}
			}

		},

		taskClasses(task){
			var cls = {}
			if(task.optional == undefined) cls['optional-undefined'] = true
			if(task.optional == false) cls['optional-false'] = true
			if( this.spec.showDescriptions && task.text && task.text.length ) cls['has-text'] = true
			return cls
		},


		toggleTaskOptional(task){
			switch( task.optional ) {
				case undefined:
					this.$set( task, 'optional', true )
				break;
				case true:
					this.$set( task, 'optional', false )
				break;
				case false:
					this.$set( task, 'optional', undefined )
				break;
			}
		},

		array_move(arr, old_index, new_index) {
		    if (new_index >= arr.length) {
		        var k = new_index - arr.length + 1;
		        while (k--) {
		            arr.push(undefined);
		        }
		    }
		    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
		    return arr; // for testing
		},



		taskCatMoveUp(taskcat,taskcat_i){
			var taskcat_new_i = taskcat_i
			taskcat_new_i -= 1
			this.array_move( this.spec.taskcats, taskcat_i, taskcat_new_i )
			this.autoSizeTextAreasDelayed()
		},

		taskCatMoveDown(taskcat,taskcat_i){
			var taskcat_new_i = taskcat_i
			taskcat_new_i += 1
			this.array_move( this.spec.taskcats, taskcat_i, taskcat_new_i )
			this.autoSizeTextAreasDelayed()
		},

		taskcatDelete(taskcat,taskcat_i){
			var sure = confirm('Vil du slette alle rækkerne i dette afsnit?')
			if(!sure) return
			this.spec.taskcats.splice( taskcat_i, 1)
			this.autoSizeTextAreasDelayed()
			this.toast('Kategori slettet')
		},

		taskDelete(task,task_i,taskcat,taskcat_i){
			var sure = confirm('Vil du slette denne række?')
			if(!sure) return
			this.spec.taskcats[taskcat_i].tasks.splice( task_i, 1)
			this.autoSizeTextAreasDelayed()
			this.toast('Række slettet')
		},

		toggleShowDescriptions(){
			if( this.spec.showDescriptions == undefined ) this.$set( this.spec, 'showDescriptions', false )
			this.$set( this.spec, 'showDescriptions', !this.spec.showDescriptions )
			var _this = this
			setTimeout(function(){ _this.autoSizeTextAreas2() },0)
		},

		autoSizeTextArea(taskcat_i,task_i){
			var el = this.$refs[ 'taskTitle'+taskcat_i+'-'+task_i ][0]
			autosize(el)
		},

		autoSizeTextArea2(taskcat_i,task_i){
			var el = this.$refs[ 'taskText'+taskcat_i+'-'+task_i ][0]
			autosize(el)
		},

		autoSizeTextAreas(){
			var textareas = document.querySelectorAll('textarea.input-task-title')
			autosize(textareas)
		},

		autoSizeTextAreas2(){
			var textareas = document.querySelectorAll('textarea.input-task-text')
			autosize(textareas)
		},

		autoSizeTextAreasDelayed(){
			var _this = this
			setTimeout(function(){
				_this.autoSizeTextAreas()
				_this.autoSizeTextAreas2()
				_this.autoSizeTextAreaNotes()
			},0)
		},

		autoSizeTextAreaNotes(){
			var el = this.$refs['notesTextArea']
			if(!el) return
			autosize(el)
		},

		downloadPDF(){
			alert('Tryk CMD+P for at prnte/gemme PDF. :)')			
		},

		cloneSpec(){
			var key = prompt('URL på projekt du ønsker at kopiere fra')
			if( !key ) return
			
			key = key.replace('https://kia.milk-studio.dk/#/project/','')

			var project = this.$store.getters['projects/getOne'](key)
			var spec = this.$store.getters['specs/getByProjectKey'](key)
			if( !spec ) {
				this.toast('Spec ikke fundet ...')
				return
			}

			fdb.ref('specs').child(this.spec.key||this.spec['.key']).update({ taskcats:spec.taskcats})      			
			this.toast('Opgavespecifikation kopieret fra '+project.name+'...')
		},


	}, //methods

	created() {
		
		var _this = this

		//globals.spec = JSON.parse(JSON.stringify(this.spec))

		//var spec = this.getSpec()
		//if( spec ) {
		//	this.$set( globals, 'spec', JSON.parse(JSON.stringify(this.getSpec() )) )
		//}

		//globals.spec.changes = JSON.parse(JSON.stringify(this.spec))
		//globals.spec.changes = {}

		//if( this.spec && !this.spec.specelements ) {
		//	this.$set( this.spec, 'specelements', {} )
		//}

		document.body.classList.add('has-spec-sheet')

		eventBus.$on('specLineRobot_onSelectEntry', function(entry){ _this.specLineRobot_onSelectEntry(entry) })

	},
	mounted(){

		// old data migration

		this.spec = this.localspec
		
		if( this.spec.type == 'fixed_prices' ) 
		if( this.spec.type == 'estimates' ) 

		this.autoSizeTextAreas()
		this.autoSizeTextAreas2()
		this.autoSizeTextAreaNotes()
	},

	destroyed(){

		document.body.classList.remove('has-spec-sheet')

	},
}
</script>



// WEBPACK FOOTER //
// Specsheet.vue?b406a456